module.exports = __webpack_public_path__ + "static/flags/BR-9028e5c3b1b859c895476e8dacea8f0b.gif";